import { useEffect, useState } from "react";

// Tailwind の md と同じ境目。これより広い画面をPCとして扱う
export const DESKTOP_MEDIA_QUERY = "(min-width: 768px)";

/**
 * メディアクエリに一致するかを返す。サーバーでの描画とハイドレーション前は判定できないため undefined を返す
 */
export function useMediaQuery(query: string): boolean | undefined {
  const [matches, setMatches] = useState<boolean>();

  useEffect(() => {
    const mediaQuery = window.matchMedia?.(query);
    if (!mediaQuery) {
      setMatches(false);
      return;
    }
    setMatches(mediaQuery.matches);
    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);
    mediaQuery.addEventListener("change", onChange);
    return () => mediaQuery.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
